import AddNewCard from './AddNewCard'

export default AddNewCard
